import { useQuery } from '@tanstack/react-query';
import jwtDecode from 'jwt-decode';
import { AppTheme, IToken, Language, TokenUserData } from '@data';
import { tokenDataKeys } from '@data/constants';
import { TokenView } from '@data/sdk/match';
import { useAppUserStore } from '@data/storage';
import { MatchingApi } from '@data/utils/axios-instance';
import i18n from '../../../app/i18n';

export const useStoredTokenData = (): IToken | undefined => {
  const { user } = useAppUserStore.getState();
  const tokenData = user?.token ? jwtDecode<IToken>(user.token) : undefined;
  return tokenData;
};

export const useTokenUserData = (): TokenUserData => {
  const tokenData = useStoredTokenData();
  const userData = tokenData?.userData;

  return {
    language: userData?.language || Language.EN,
    roles: userData?.roles || [],
    theme: userData?.theme || AppTheme.CUREWIKI,
    userId: userData?.userId || '',
    firstName: userData?.firstName || '',
    lastName: userData?.lastName || '',
    phoneNumber: tokenData?.phone_number || '',
    email: tokenData?.email || '',
    parentAccountId: userData?.parentAccountId,
    companyName: userData?.companyName || '',
    companyRole: userData?.companyRole || '',
    isAnonymous: userData?.isAnonymous || false,
  };
};

export const useTokenData = (token: string) =>
  useQuery<TokenView, Error>({
    queryKey: tokenDataKeys.lists(),
    queryFn: async () => {
      const response = await MatchingApi.token.getToken({ token });

      if (response.data.language !== i18n.language) {
        i18n.changeLanguage(response.data.language);
      }

      return response.data;
    },
    enabled: !!token,
  });
